// extracted by mini-css-extract-plugin
module.exports = {"menuBar":"MenuBar_menuBar__3qH49","menuItem":"MenuBar_menuItem__1UIMJ"};